module.exports = __webpack_public_path__ + "img/story_slide_1_on.74bf5bc1.jpg";